import { render, staticRenderFns } from "./GoBackFooter.vue?vue&type=template&id=35bc338b"
import script from "./GoBackFooter.vue?vue&type=script&lang=js"
export * from "./GoBackFooter.vue?vue&type=script&lang=js"
import style0 from "./GoBackFooter.vue?vue&type=style&index=0&id=35bc338b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports